/* eslint-disable no-magic-numbers */
import { Component, Input, OnInit } from '@angular/core';
import { OnboardingStepResponse } from 'src/app/core/models/onboarding.step.model';
import { KycService } from 'src/app/core/services/kyc.service';

@Component({
  selector: 'app-kyc-progress',
  templateUrl: './kyc-progress.component.html',
  styleUrls: ['./kyc-progress.component.scss',],
})
export class KycProgressComponent implements OnInit {

  @Input() subscriptionId!: string;
  stepGroup = 0;
  totalSteps: number = 18;
  currentStep: number = 1;
  progress: number = 0;

  constructor(
    private _kycService: KycService
  ) { }

  ngOnInit(): void {
    this._kycService.getSubscriptionKycOnboardingSteps(this.subscriptionId).subscribe({
      next: (response: OnboardingStepResponse) => {
        if (response?.stepsRequired) {
          const onboardingSteps = response.stepsRequired;
          this.totalSteps = Math.max(onboardingSteps.length, this.totalSteps);
          this.currentStep = onboardingSteps
            .sort((a, b) => a.order - b.order)
            .findIndex(s => s.status != 'SUBMITTED') || 1;
          this.calculateProgress();
        }
      },
    });
  }

  calculateProgress() {
    this.progress = (this.currentStep / this.totalSteps) * 100;
    // Divided into 5 groups
    this.stepGroup = Math.ceil(this.currentStep / (this.totalSteps / 4));
  }
}
